import { MaskedInputProps } from '../../types';
import { MaskedInput } from './Input';

type InputCPFProps = MaskedInputProps & {
  readOnly?: boolean;
};

export function InputCPF(props: InputCPFProps) {
  return (
    <MaskedInput {...props} mask="000.000.000-00" readOnly={props.readOnly} />
  );
}
